import http from "../helpers/http";
import https from "../helpers/https";

export const getPaymentLink = async (code) => {
  const response = await http().get(`/payment-link/?code=${code}`);
  return response.data;
};

export const makePayment = async (payload) => {
  const response = await http().post("/payment-link/payment", payload);
  return response.data;
};

export const paymentStatus = async (id) => {
  const response = await https().get(`/status/${id}`);
  return response.data;
};

export const transactionStatus = async (id) => {
  const response = await http().get(`/payment-link/status/${id}`);
  return response.data;
};
